<template>
  <ObjectListTabs>
    <template slot-scope="{}">
      <b-nav-item :to="{name: 'fan-profile', params: {id: user.id}}">About</b-nav-item>
      <b-nav-item :to="{name: 'fan-profile-playlists', params: {id: user.id}}">Playlists</b-nav-item>
      <b-nav-item :to="{name: 'fan-featured', params: {id: user.id}}">Featured In</b-nav-item>
    </template>
    <template slot="cmd" slot-scope="{}">
      <b-button variant="secondary" :to="{name: 'fan-profile-edit'}" size="sm" v-if="user.id === currentUser.id">
        Edit Profile
      </b-button>
      <b-button variant="secondary" :to="{name: 'artist-about', params: {artistId: user.artist_id}}" size="sm"  v-if="user.artist_id && (user.id !== currentUser.id)">
        Artist Profile
      </b-button>
    </template>
    <template slot="mobileCmd" slot-scope="{}">
      <b-nav-item :to="{name: 'fan-profile-edit'}" v-if="user.id === currentUser.id">Edit Profile</b-nav-item>
      <b-nav-item :to="{name: 'artist-about', params: {artistId: user.artist_id}}" v-if="user.artist_id && (user.id !== currentUser.id)">Artist Profile</b-nav-item>
    </template>
  </ObjectListTabs>
</template>

<script>
import { mapGetters } from 'vuex'

import ObjectListTabs from '@/components/widgets/ObjectListTabs'

export default {
  name: 'FanProfileTabs',
  props: ['user'],
  components: {
    ObjectListTabs
  },
  computed: {
    ...mapGetters('profile', ['currentUser'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/FanProfileTabs.vue